import React, { Fragment, useState } from "react";
import { Modal, Row, Col, Spinner } from "react-bootstrap";
import styled from "styled-components";
import {
  CustomControl,
  CustomButton,
  CustomSelect,
  CustomInput,
  FormikFieldError,
} from "components/CustomForm";
import { MdClose } from "react-icons/md";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import {
  createIngredient,
  getUnits,
  updateIngredient,
} from "network//apis/InformationApi";
import { isBlank, getErrorMessage } from "helpers/strings";

const ModalHolder = styled(Modal)`
  font-family: "YEKAN-BAKH-MEDIUM";
`;

const FormHolder = styled(Form)`
  direction: rtl;
`;

const Header = styled.div`
  font-size: 18pt;
  width: 100%;
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

const CloseButton = styled.div`
  background-color: #424250;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  top: 12px;
  right: 10px;
`;

const AddConcentrateCompundModal = ({
  isOpen,
  onClose,
  onCreateSuccess,
  data,
  ...rest
}) => {
  const isEditMode = () => data && data != null;
  const getDefaultUnit = () =>
    isEditMode()
      ? { label: data.default_unit.name, value: data.default_unit.unit_id }
      : null;

  const [loading, setLoading] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(getDefaultUnit());

  const { data: unitsData } = useQuery(["get-units"], () => getUnits(), {
    refetchOnWindowFocus: false,
  });

  const concentrateMutation = useMutation(
    isEditMode() ? updateIngredient : createIngredient,
    {
      onSuccess: (res) => {
        if (res && res.data) {
          toast(`با موفقیت ${isEditMode() ? "ویرایش" : "ایجاد"} گردید`, {
            type: "success",
            position: "bottom-right",
          });
          onCreateSuccess?.();
          onClose();
        }
      },
      onError: (err) => {
        toast(getErrorMessage(err), {
          type: "error",
          position: "bottom-right",
        });
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  const getUnitOptions = () =>
    unitsData?.data
      ? unitsData.data.map((unit, index) => {
          return { value: unit?.unit_id, label: unit?.name };
        })
      : [];

  return (
    <ModalHolder
      show={isOpen}
      size={"lg"}
      centered
      animation={false}
      onHide={onClose}
      {...rest}
    >
      <Modal.Body className="px-5">
        <CloseButton onClick={onClose}>
          <MdClose color="#fff" />
        </CloseButton>
        <Header>
          <span>{isEditMode() ? "ویرایش" : "افزودن"} ترکیب کنسانتره</span>
        </Header>
        <Formik
          initialValues={{
            name: data?.name,
            description: data?.description,
          }}
          validate={(values) => {
            const errors = {};
            if (isBlank(values.name)) {
              errors.name = "ضروری";
            } else if (!selectedUnit) {
              errors.default_unit_id = "ضروری";
            } else if (isBlank(values.description)) {
              errors.description = "ضروری";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setLoading(true);
            concentrateMutation.mutate({
              id: data?.item_id,
              default_unit_id: selectedUnit?.value,
              ...values,
            });
          }}
        >
          {({ submitForm }) => (
            <FormHolder>
              <Fragment>
                <div className="mb-2 w-100 d-flex justify-content-between">
                <Col md={6} className="ps-1">
                    <Field type="text" name="name">
                      {({ field, meta: { touched, error } }) => (
                        <CustomInput
                          className={touched && error ? "invalid" : ""}
                          error={!isBlank(error)}
                          {...field}
                          placeholder="نام ترکیب"
                          radius="14"
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="name"
                      component={FormikFieldError}
                    />
                  </Col>
                  <Col md={6} className="pe-1">
                    <Field type="text" name="default_unit_id">
                      {({ field, meta: { touched, error } }) => (
                        <CustomSelect
                          className={touched && error ? "invalid" : ""}
                          error={!isBlank(error)}
                          {...field}
                          placeholder="واحد سنجش"
                          radius="14"
                          options={getUnitOptions()}
                          onChange={setSelectedUnit}
                          value={selectedUnit}
                          menuPosition='fixed'
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="default_unit_id"
                      component={FormikFieldError}
                    />
                  </Col>                 
                </div>
                <div className="w-100">
                  <Field type="text" name="description">
                    {({ field, meta: { touched, error } }) => (
                      <CustomInput
                        className={touched && error ? "invalid" : ""}
                        error={!isBlank(error)}
                        {...field}
                        placeholder="توضیحات"
                        radius="14"
                      />
                    )}
                  </Field>
                  <ErrorMessage
                      name="description"
                      component={FormikFieldError}
                    />
                </div>
                <div className="d-flex justify-content-center mt-4 mb-3 w-100">
                <CustomButton
                    className="ms-3 w-25"
                    color="#7300FF"
                    fontSize={16}
					onClick={onClose}
                  >
                    انصراف
                  </CustomButton>
                  <CustomButton
                    fontSize={16}
                    onClick={submitForm}
                    disabled={loading}
                    className="w-25 d-flex align-items-center justify-content-center"
                  >
                    {loading ? (
                      <Spinner animation="border" role="status" size="sm" />
                    ) : (
                      <span>ثبت</span>
                    )}
                  </CustomButton>                  
                </div>
              </Fragment>
            </FormHolder>
          )}
        </Formik>
      </Modal.Body>
    </ModalHolder>
  );
};

export default AddConcentrateCompundModal;
